// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isFromEmailDomains = arrayOf(
  objectOf({
    domain: string,
    ip_pool_name: string,
    esp: number,
  })
);
